import request from '../utils/request'
import global from '../config/global'
import coreServices from './core'
import dayjs from 'dayjs';

import { CipherType } from '../core-js/src/enums'
import { CipherView } from '../core-js/src/models/view'
import { CipherRequest } from '../core-js/src/models/request/cipherRequest'

async function list_ciphers(projectId = null) {
  return await global.jsCore.searchService.searchCiphers(
    null,
    [
      c => !c.isDeleted && c.type === CipherType.Secret,
      c => !projectId || c.organizationId == projectId,
    ],
    null
  ) || []
}

async function get_payload(value, projectId) {
  const cipher = new CipherView()
  cipher.type = CipherType.Secret
  cipher.organizationId = projectId
  cipher.environmentId = value.environmentId
  cipher.secret = {
    key: value.key,
    value: value.value,
    description: value.description,
  }
  const cipherEnc = await global.jsCore.cipherService.encrypt(cipher)
  const cipherRequest = new CipherRequest(cipherEnc)
  const hash = await coreServices.hash_key_with_project_id(value.key, projectId)

  return {
    key: cipherRequest.secret.key,
    value: cipherRequest.secret.value,
    description: cipherRequest.secret.description,
    environment_id: cipherRequest.environmentId || null,
    hash: hash,
    expired_date: value.expiredDate ? dayjs(value.expiredDate).unix() : null
  }
}

async function hash_payload(ciphers) {
  const promises = ciphers.map(async (c) => ({
    id: c.id,
    hash: await coreServices.hash_key_with_project_id(c.secret.key, c.organizationId)
  }))
  const hashSecrets = await Promise.all(promises);
  return {
    secrets: hashSecrets
  };
}

function list(project_id, params = {}) {
  return request({
    url: global.endpoint.PROJECT_SECRETS.replace(':id', project_id),
    method: 'get',
    params
  })
}

function get(project_id, id, params = {}) {
  return request({
    url: global.endpoint.PROJECT_SECRET.replace(':id', project_id).replace(':secret_id', id),
    method: 'get',
    params
  })
}

function create(project_id, data = {}) {
  return request({
    url: global.endpoint.PROJECT_SECRETS.replace(':id', project_id),
    method: 'post',
    data
  })
}

function create_multiple(project_id, data = []) {
  return request({
    url: global.endpoint.PROJECT_SECRETS_CREATE_MULTIPLE.replace(':id', project_id),
    method: 'post',
    data
  })
}

function update(project_id, id, data = {}) {
  return request({
    url: global.endpoint.PROJECT_SECRET.replace(':id', project_id).replace(':secret_id', id),
    method: 'put',
    data
  })
}

function update_multiple(project_id, data = {}) {
  return request({
    url: global.endpoint.PROJECT_SECRETS_UPDATE_MULTIPLE.replace(':id', project_id),
    method: 'put',
    data
  })
}

function remove(project_id, id) {
  return request({
    url: global.endpoint.PROJECT_SECRET.replace(':id', project_id).replace(':secret_id', id),
    method: 'delete'
  })
}

function remove_multiple(project_id, ids) {
  return request({
    url: global.endpoint.PROJECT_SECRETS_DELETE_MULTIPLE.replace(':id', project_id),
    method: 'post',
    data: {
      secrets: ids
    }
  })
}

export default {
  list_ciphers,
  get_payload,
  hash_payload,
  list,
  get,
  create,
  create_multiple,
  update,
  update_multiple,
  remove,
  remove_multiple
}
